import InputEmail from "./inputEmail";

export default InputEmail;